import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门分类
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-medium">
                <span>浏览全部</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}